/**
 * useDragger hooks
 */
import { useEffect, useRef } from 'react';

const WIDTH = 128;
const HEIGHT = 104;
const max = 0.72;
const min = 0.388;
let calcMaxScale = 1;
let calcMinScale = 1;

const useZoom = (
  zoomTarget: any,
  target: any,
  startEvent = (e: any, obj: any) => {},
  moveEvent = (e: any, obj: any) => {},
  endEvent = (e: any, obj: any) => {},
  initScale = (obj: any) => {},
  deps = [0.8], // zoom  moveLimit
  op = {},
) => {
  let options = { zoom: true, row: 1, col: 1, ...op };
  const ratio = window.devicePixelRatio * 2;
  let start = useRef(),
    move = useRef(),
    end = useRef();
  let pageX = 0,
    pageY = 0;

  let re_pageX = 0,
    re_pageY = 0,
    re_size = 1,
    distance = 0;
  let firstClick = true;
  let touchStartHandler = function(e: any) {
    if (options.zoom && e && e.touches && e.touches[1]) {
      // 两根胡萝卜
      e.preventDefault();
      pageX = Math.floor(e.touches[0].pageX); // 手指1
      pageY = Math.floor(e.touches[0].pageY);
      re_pageX = Math.floor(e.touches[1].pageX); // 手指2
      re_pageY = Math.floor(e.touches[1].pageY);
      // re_pageX = 100
      // re_pageY = 100
      distance = Math.floor(
        Math.sqrt(Math.pow(re_pageX - pageX, 2) + Math.pow(re_pageY - pageY, 2)),
      );
      re_size = target?.current?.style.getPropertyValue('--scale') || calcMaxScale; // 1 ->0.8
    } else {
      // 1根胡萝卜
      re_size = target?.current?.style.getPropertyValue('--scale') || calcMaxScale;
    }
    startEvent(e, { size: re_size, firstZoom: firstClick });
    firstClick = false;
  };
  let touchMoveHandler = function(e: any) {
    // debugger
    if (options.zoom && e && e.touches && e.touches[1]) {
      e.preventDefault();
      pageX = Math.floor(e.touches[0].pageX); // 手指1
      pageY = Math.floor(e.touches[0].pageY);
      re_pageX = Math.floor(e.touches[1].pageX); // 手指2
      re_pageY = Math.floor(e.touches[1].pageY);

      let m_distance = Math.sqrt(Math.pow(re_pageX - pageX, 2) + Math.pow(re_pageY - pageY, 2));
      let result = (m_distance / distance) * re_size;

      // scale 计算下，按照最大canvas 来

      re_size = Math.floor(result * 1000) / 1000;
      re_size =
        re_size >= calcMaxScale ? calcMaxScale : re_size <= calcMinScale ? calcMinScale : re_size;
      target?.current?.style.setProperty('--scale', `${re_size}`);
    }

    moveEvent(e, { size: re_size });
  };
  let touchEndHandler = function(e: any) {
    // e.preventDefault()
    re_size =
      re_size >= calcMaxScale ? calcMaxScale : re_size <= calcMinScale ? calcMinScale : re_size;
    target?.current?.style.setProperty('--scale', `${re_size}`);
    endEvent(e, { size: re_size });
  };
  let calcScale = function() {
    // 计算最小、最大 缩放比例；
    const screenWid = window.screen.width - 20;
    const width = screenWid * ratio;
    const sca = width / (options.row * WIDTH);
    calcMinScale = sca < min ? min : sca > max ? max : sca; // 全屏显示座位的最小缩放

    // 最大的
    const maxArea = 16777210;
    const scaMax = Math.sqrt(maxArea / (options.row * options.col * WIDTH * HEIGHT));

    calcMaxScale = scaMax > max ? max : scaMax < min ? min : scaMax;
    // console.log(screenWid, width, ratio, sca, scaMax, calcMinScale, calcMaxScale, options);
    initScale({ size: calcMinScale });
  };
  useEffect(() => {
    start.current = zoomTarget?.current?.addEventListener('touchstart', touchStartHandler, {
      passive: false
    });
    move.current = zoomTarget?.current?.addEventListener('touchmove', touchMoveHandler, {
      passive: false
    });
    end.current = zoomTarget?.current?.addEventListener('touchend', touchEndHandler, {
      passive: false
    });
    // 开始就触发一次touch
    calcScale();
  }, []);

  useEffect(() => {
    re_size = deps[0];
  }, []);

  let stop = () => {
    zoomTarget.current.removeEventListener(start.current);
    zoomTarget.current.removeEventListener(move.current);
    zoomTarget.current.removeEventListener(end.current);
  };
  return [stop];
};
export default useZoom;
